import React from "react";
import clsx from "clsx";
import {createUseStyles} from "react-jss";
import {Theme} from "engage-client/theme";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {
	LeaderboardContentSize,
	LeaderboardContentSizeCompact,
	LeaderboardRowHeight,
	LeaderboardRowHeightCompact
} from "../accessory/accessoryConstants";

const useStyles = createUseStyles<Theme>((theme) => ({
	leaderboardTitleRow: {
		flex: 1,
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: props => props.rowHeight,
	},

	icon: {
		margin:  props => (props.rowHeight - props.contentSize) / 2,
		height:  props => props.contentSize,
		width: props => props.contentSize,
	},

	name: {
		flex: 1,
		margin: props => (props.rowHeight - props.contentSize) / 2,
		marginLeft: 16,
		[theme.breakpoints.down("lg")]: {
			marginLeft: 8,
		},
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		fontVariant: "small-caps"
	},
}));

type LRTitleProps = {
	name: string
	iconFilename?: string
	className?: string
	extraStyles?: any
	compact: boolean
}

export default function LeaderboardTitleRow(props:LRTitleProps) {
	const contentSize = props.compact ? LeaderboardContentSizeCompact : LeaderboardContentSize;
	const rowHeight = props.compact ? LeaderboardRowHeightCompact : LeaderboardRowHeight;
	const classes = useStyles({
		contentSize,
		rowHeight,
	});

	return <div className={clsx(classes.leaderboardTitleRow, props.className)} style={props.extraStyles}>
		{props.iconFilename && <img className={classes.icon} src={`/assets/icons/common/${props.iconFilename}.svg`} alt={`Icon for ${props.name}`}/>}
		<DisplayText className={classes.name} variant={TextVariant.s16reg} lineHeight={1.12} color="white">{props.name}</DisplayText>
	</div>;
};